import {
  createStyles,
  Theme,
  withStyles,
  WithStyles
} from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import classnames from 'classnames';
import React from 'react';

const styles = (theme: Theme) =>
  createStyles({
    overFlowText: {
      // whiteSpace: "nowrap",
      // overflow: "hidden",
      // textOverflow: "ellipsis"
    },
    srno: {
      maxWidth: '5%',
      paddingLeft: '1%'
    },
    customer: {
      maxWidth: '15%',
      width: '10%',
      paddingLeft: '2%',
      whiteSpace: 'nowrap',
      marginRight: '0.825rem',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    feedName: {
      maxWidth: '15%',
      width: '10%',
      paddingLeft: '2%',
      whiteSpace: 'pre-wrap',
      marginRight: '0.825rem'
    },
    playlistDate: {
      maxWidth: '8%',
      paddingLeft: '1%',
      whiteSpace: 'pre-wrap',
      marginRight: '0.825rem'
    },
    lastPublishedPlaylistId: {
      maxWidth: '8%',
      paddingLeft: '1%',
      whiteSpace: 'pre-wrap',
      marginRight: '0.825rem'
    },
    missingAssetsOnCloud: {
      maxWidth: '8%',
      paddingLeft: '1%',
      whiteSpace: 'pre-wrap',
      marginRight: '0.825rem'
    },
    headendStatus: {
      maxWidth: '8%',
      paddingLeft: '1%',
      whiteSpace: 'pre-wrap',
      marginRight: '0.825rem'
    },
    missingHeadendStatus: {
      maxWidth: '8%',
      paddingLeft: '1%',
      whiteSpace: 'pre-wrap',
      marginRight: '0.825rem'
    },
    playlistValidation: {
      maxWidth: '10%',
      paddingLeft: '1%',
      whiteSpace: 'pre-wrap',
      marginRight: '0.825rem',
      textTransform: 'uppercase'
    },
    latestPlaylistStatus: {
      maxWidth: '10%',
      paddingLeft: '1%',
      paddingRight: '1%',
      whiteSpace: 'pre-wrap',
      marginRight: '0.825rem'
    },
    actions: {
      maxWidth: '12%',
      width: '12%',
      paddingLeft: '1%',
      paddingRight: '2%',
      whiteSpace: 'pre-wrap'
    }
  });

export const SrNo = withStyles(styles)((props: IColumnProps) => {
  return (
    <TableCell
      padding={'none'}
      className={classnames(props.classes.srno, props.className)}
    >
      {props.children}
    </TableCell>
  );
});

export const Customer = withStyles(styles)((props: IColumnProps) => {
  return (
    <TableCell
      padding={'none'}
      className={classnames(
        props.classes.customer,
        props.classes.overFlowText,
        props.className
      )}
    >
      {props.children}
    </TableCell>
  );
});

export const FeedName = withStyles(styles)((props: IColumnProps) => {
  return (
    <TableCell
      padding={'none'}
      className={classnames(props.classes.feedName, props.className)}
    >
      {props.children}
    </TableCell>
  );
});

export const PlaylistDate = withStyles(styles)((props: IColumnProps) => {
  return (
    <TableCell
      padding={'none'}
      className={classnames(props.classes.playlistDate, props.className)}
    >
      {props.children}
    </TableCell>
  );
});

export const LastPublishedPlaylistId = withStyles(styles)(
  (props: IColumnProps) => {
    return (
      <TableCell
        padding={'none'}
        className={classnames(
          props.classes.lastPublishedPlaylistId,
          props.className
        )}
      >
        {props.children}
      </TableCell>
    );
  }
);

export const MissingAssetsOnCloud = withStyles(styles)(
  (props: IColumnProps) => {
    return (
      <TableCell
        padding={'none'}
        className={classnames(
          props.classes.missingAssetsOnCloud,
          props.className
        )}
      >
        {props.children}
      </TableCell>
    );
  }
);

export const HeadendStatus = withStyles(styles)((props: IColumnProps) => {
  return (
    <TableCell
      padding={'none'}
      className={classnames(props.classes.headendStatus, props.className)}
    >
      {props.children}
    </TableCell>
  );
});
export const MissingHeadendStatus = withStyles(styles)(
  (props: IColumnProps) => {
    return (
      <TableCell
        padding={'none'}
        className={classnames(
          props.classes.missingHeadendStatus,
          props.className
        )}
      >
        {props.children}
      </TableCell>
    );
  }
);
export const PlaylistValidation = withStyles(styles)((props: IColumnProps) => {
  return (
    <TableCell
      padding={'none'}
      className={classnames(props.classes.playlistValidation, props.className)}
    >
      {props.children}
    </TableCell>
  );
});
export const LatestPlaylistStatus = withStyles(styles)(
  (props: IColumnProps) => {
    return (
      <TableCell
        padding={'none'}
        className={classnames(
          props.classes.latestPlaylistStatus,
          props.className
        )}
      >
        {props.children}
      </TableCell>
    );
  }
);

export const Actions = withStyles(styles)((props: IColumnProps) => {
  return (
    <TableCell
      style={{ paddingLeft: '2%' }}
      padding={'none'}
      className={classnames(props.classes.actions, props.className)}
    >
      {props.children}
    </TableCell>
  );
});

interface IColumnProps extends WithStyles<typeof styles> {
  children?: React.ReactNode;
  className?: any;
}
